// =============================================================================
// FILE STATUS HEADER  (lihat /app/memory/MASTER_BLUEPRINT.md A7)
// status   : ACTIVE (Supabase migration V2 - PREVIEW ONLY)
// version  : 3.0
// updated  : 2026-06-21
// protected: NO
// changelog: v3.0 (UAT-02 Fase 2) - Request->Dispatch. Kacab buat REQUEST (tanpa QR);
//            Admin Gudang region scan QR (exact-match) -> dispatch; Staff Store terima.
// =============================================================================
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Truck } from "lucide-react";
import { toast } from "sonner";
import { useV2Auth } from "@/v2/V2AuthContext";
import { RequestDispatchFlow } from "@/v2/components/RequestDispatchFlow";
import { WAREHOUSES, STORES, defaultGudang, defaultStore, allowedWarehouses } from "@/v2/components/helpers";
import { GUDANG, STORE, KACAB } from "@/v2/menu";

export default function PengirimanPage() {
  const { me } = useV2Auth();
  const location = useLocation();
  const prefill = location.state?.prefill || null;
  const focusShipment = location.state?.focusShipment || null;
  const role = me?.role;
  const gudang = GUDANG.includes(role);
  const kacab = KACAB.includes(role);
  const store = STORE.includes(role);

  // P1: bila datang dari "Lihat Pengiriman" — beri tahu user SJ aktif yang sudah ada
  // (cegah membuat Surat Jalan dobel; arahkan ke dokumen existing pada daftar).
  useEffect(() => {
    if (focusShipment?.sjNo) {
      toast.info(`Permintaan ${focusShipment.requestNo || ""} sudah punya pengiriman aktif: ${focusShipment.sjNo}. Cari dokumen ini pada Daftar Dokumen di bawah.`);
    }
  }, [focusShipment]);

  // P0-C Fase 4: store tujuan difilter sesuai region gudang asal (UI). Backend tetap enforce.
  const STORE_BY_WH = { GUDANG_SBY: ["STORE_AREMA"], GUDANG_SMD: ["STORE_BORNEO"] };
  const storesForWh = (src) => STORE_BY_WH[src] || STORES;
  const defSrc = defaultGudang(me?.region);

  return (
    <RequestDispatchFlow
      testid="v2-pengiriman-page"
      title="Pengiriman Store"
      icon={Truck}
      docType="shipment"
      listPath="/api/v2/shipments"
      createPath="/api/v2/shipments"
      dispatchPath={(id) => `/api/v2/shipments/${id}/dispatch`}
      receivePath={(id) => `/api/v2/shipments/${id}/receive`}
      progressPath={(id) => `/api/v2/shipments/${id}/receive-progress`}
      cancelPath={(id) => `/api/v2/shipments/${id}/cancel`}
      sourceLabel="Gudang Asal"
      targetLabel="Store Tujuan"
      sourceOptions={allowedWarehouses(me)}
      targetOptions={(src) => storesForWh(src)}
      defaultSource={defSrc}
      defaultTarget={storesForWh(defSrc)[0]}
      buildRequestBody={({ source, target, lines, storeRequestId }) => ({ from_location: source, to_store: target, request_lines: lines, store_request_id: storeRequestId || null })}
      canCreate={kacab}
      canDispatch={gudang}
      canReceive={store}
      canCancel={kacab || gudang}
      receiverLocation={defaultStore(me?.region)}
      allowMou
      createLabel="Ajukan Pengiriman"
      prefill={prefill}
      sellPlanCheck
      emptyTitle="Belum ada pengiriman store"
      emptyDescription="Pengiriman muncul di sini setelah Kepala Cabang mengajukan permintaan, lalu Admin Gudang scan QR dan menekan Konfirmasi Kirim."
    />
  );
}
